module.exports = __webpack_public_path__ + "img/RightArrow.675cb903.svg";